import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import OperationHistoryPageContainerComponent from './OperationHistoryPageContainer/OperationHistoryPageContainer.container';

const OperationsHistoryPage = ({ t }) => {
    const staticNames = t?.historyPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content finance">
                <OperationHistoryPageContainerComponent />
            </section>
        </React.Fragment>
    );
};

OperationsHistoryPage.propTypes = {
    t: PropTypes.object
};

export default withTranslation(OperationsHistoryPage);
